module.exports = __webpack_public_path__ + "static/media/day-mode.2db4b37b.svg";